export const PUBLIC_CONVERSION_EXPERIMENT = "app_rescue_conversion_2026_08";
export const APP_RESCUE_CONVERSION_GOAL = "diagnostic_booked";
